module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.instagram) ? _c('div', {
    staticClass: "instagram-grid"
  }, _vm._l((_vm.instagram), function(image, i) {
    return _c('a', {
      key: i,
      staticClass: "instagram-grid__thumb",
      attrs: {
        "href": image.permalink,
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [_c('img', {
      staticClass: "instagram-grid__image",
      attrs: {
        "src": image.source
      }
    })])
  })) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0bee31bf","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/block/instagram-grid/instagram-grid.pug
// module id = 543
// module chunks = 1